import { useEffect } from 'react';

import { NotificationPosition } from 'core/enums';
import { useNotificationContext } from 'core/states';

interface IParams {
  isLoadFailed: boolean;
  title: string;
  message: string;
}

// AG Grid reads suppressNoRowsOverlay only at init, so the "no rows" overlay is hidden with CSS.
export const hiddenNoRowsOverlaySx = {
  display: 'contents',
  '& .ag-overlay-no-rows-wrapper': { display: 'none' },
};

export const useLoadErrorNotification = ({ isLoadFailed, title, message }: IParams) => {
  const { showErrorNotification, clearDrawerNotification } = useNotificationContext();

  useEffect(() => {
    if (!isLoadFailed) {
      return;
    }

    showErrorNotification({ title, message, disableAutoClose: true }, NotificationPosition.DRAWER);

    return clearDrawerNotification;
  }, [isLoadFailed, title, message, showErrorNotification, clearDrawerNotification]);
};
